// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Application Designer — editor chrome, and the meaning of every cosmetic.
 *
 * Two halves.
 *
 * The first is the editor: the command bar, the per-element design chrome, the
 * hidden tray and the properties panel. These are the rules the Patient Summary
 * Design View shipped with, renamed from \`.emr-summary-design-*\` to \`.ad-*\` so
 * the next designable page inherits the same look instead of copying it.
 *
 * The second is the cosmetic contract. A stored cosmetic never becomes an inline
 * style: \`cosmeticStyleProps\` emits a CSS custom property plus a marker
 * attribute, and the rules below are the ONLY place that decides what a marker
 * does. A property with no rule here is inert, which is what makes the stored
 * value safe — a layout cannot express a declaration this file has not agreed to.
 *
 * Each rule targets \`.ad-item[marker] > :first-child\`, the native element itself,
 * so a page's own component keeps its markup and only the declarations that were
 * actually set are overridden. Three classes of specificity clears
 * \`.emr-chart .emr-chart-card\` without needing \`!important\`.
 */

.ad-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.ad-bar__banner {
  margin: 0;
  flex: 1 1 280px;
  font-size: var(--emr-type-helper);
  color: var(--emr-chart-muted);
}

.ad-bar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ad-bar__btn,
.ad-item__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid var(--emr-chart-border);
  background: #fff;
  color: var(--emr-chart-text);
  font-size: var(--emr-type-button-compact);
  font-weight: 600;
}

.ad-bar__btn.is-primary {
  border-color: var(--emr-chart-primary);
  background: var(--emr-chart-primary);
  color: #fff;
}

.ad-bar__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ad-item__design {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 6px;
  border: 1px dashed #9dbbe0;
  background: #f8fbff;
}

.ad-item__design.is-selected {
  border-color: var(--emr-chart-primary);
  border-style: solid;
  background: #eef6ff;
}

.ad-item__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.ad-item__label {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  color: var(--emr-chart-muted);
  cursor: pointer;
}

.ad-item__label[aria-pressed="true"] {
  color: var(--emr-chart-primary);
  text-decoration: underline;
}

.ad-item__grip {
  display: inline-flex;
  color: #7a8ea6;
  cursor: grab;
}

.ad-item__btn {
  height: 24px;
  padding: 0 6px;
}

.ad-item__body {
  min-width: 0;
}

.ad-item {
  min-width: 0;
}

.ad-hidden {
  margin-top: 12px;
  padding: 12px;
  border: 1px dashed #c5cdd6;
  background: #fafbfc;
}

.ad-hidden h3 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  font-size: var(--emr-type-card-title);
}

.ad-hidden ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ad-hidden li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/*
 * The panel sits below the page it edits, so it is as wide as the page. Laying
 * the groups out in columns keeps every control beside its own label: a single
 * full-width column would put the label at one edge of the screen and its
 * control at the other, which is a long way to travel to change a padding.
 *
 * The panel is an <aside>, and the Materialize overlay prefixed onto
 * \`.emr-mz-dashboard\` (see craco.config.js) sets \`display: block\` on every
 * semantic element at one class plus one element — which outranks a single
 * designer class. Without the prefixed selector here the panel stays a block and
 * collapses back to one full-width column.
 */
.emr-mz-dashboard .ad-props,
.ad-props {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid var(--emr-chart-border);
  background: #fff;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 0 24px;
  align-items: start;
}

.ad-props__title,
.ad-props__note {
  grid-column: 1 / -1;
}

.ad-props__title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0 0 8px;
  font-size: var(--emr-type-card-title);
}

.ad-props__subject {
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  color: var(--emr-chart-primary);
}

.ad-props__note {
  margin: 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-chart-muted);
}

.ad-props__group {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid var(--emr-chart-border);
}

.ad-props__group h4 {
  margin: 0 0 6px;
  font-size: var(--emr-type-metadata);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--emr-chart-muted);
}

/* Label and control in one row of the group's own narrow column. */
.ad-props__field {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
  min-height: 26px;
}

.ad-props__field > label {
  font-size: var(--emr-type-helper);
  color: var(--emr-chart-text);
}

/*
 * Materialize form controls, opted out of.
 *
 * The overlay replaces native controls with its own JS widgets, so it hides what
 * it means to replace: \`select { display: none }\`, and \`[type=checkbox]\` moved to
 * zero size at zero opacity. It also restyles text-like inputs — including
 * \`number\` — into a 3rem underline-only field at 16px with content-box sizing and
 * an 8px bottom margin. All of that is prefixed with \`.emr-mz-dashboard\`, which
 * puts \`input[type=number]:not(.browser-default)\` at three classes and one
 * element: past anything the panel can reach on specificity alone. This is the
 * same opt-out the Form Designer makes, for the same reason and in the same way.
 *
 * A control that is in the DOM with no box is worse than a missing control,
 * because it looks like a rendering glitch rather than a bug, so these rules are
 * pinned by \`emr-application-designer.test.js\`.
 */
.emr-mz-dashboard .ad-props__field select,
.ad-props__field select {
  display: block;
  appearance: auto;
  -webkit-appearance: auto;
}

.emr-mz-dashboard .ad-props input[type="checkbox"],
.ad-props input[type="checkbox"] {
  position: static !important;
  left: auto !important;
  width: 13px !important;
  height: 13px !important;
  margin: 0 !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  accent-color: var(--emr-chart-primary);
}

.emr-mz-dashboard .ad-props__field select,
.emr-mz-dashboard .ad-props__field input[type="number"],
.ad-props__field select,
.ad-props__field input[type="number"] {
  box-sizing: border-box !important;
  height: 24px !important;
  width: 104px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  border: 1px solid var(--emr-chart-border) !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
  font-size: var(--emr-type-helper) !important;
}

.ad-props__color {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ad-props__color input[type="color"] {
  width: 32px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--emr-chart-border);
  background: #fff;
}

.ad-props__clear {
  height: 24px;
  padding: 0 6px;
  border: 1px solid var(--emr-chart-border);
  background: #fff;
  font-size: var(--emr-type-metadata);
}

.ad-props__clear:disabled {
  opacity: 0.45;
}

.ad-props__sides {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ad-props__sides label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: var(--emr-type-metadata);
  color: var(--emr-chart-muted);
}

/* ---------------------------------------------------------------------------
 * Cosmetic contract. One rule per allowlisted property; the marker attribute
 * is what activates it, so an unset property changes nothing.
 * ------------------------------------------------------------------------- */

.ad-item[data-ad-background-color] > :first-child {
  background: var(--ad-background);
}

.ad-item[data-ad-corner-radius] > :first-child {
  border-radius: var(--ad-corner-radius);
}

.ad-item[data-ad-shadow] > :first-child {
  box-shadow: var(--ad-shadow);
}

.ad-item[data-ad-border-color] > :first-child {
  border-color: var(--ad-border-color);
}

.ad-item[data-ad-border-style] > :first-child {
  border-style: var(--ad-border-style);
}

/*
 * Thickness is per side so "which edges are visible" is the same property as
 * "how thick": an edge the user turned off is emitted as 0px rather than
 * needing a second declaration. Setting a thickness therefore replaces the
 * card's own border shorthand on every edge, including the accent edge
 * \`.emr-chart-card\` draws on the right.
 *
 * Choosing edges alone activates the same rule, so "which sides are visible" is
 * not inert until a thickness is also picked.
 */
.ad-item[data-ad-border-sides] > :first-child,
.ad-item[data-ad-border-width] > :first-child {
  border-top-width: var(--ad-border-top-width);
  border-right-width: var(--ad-border-right-width);
  border-bottom-width: var(--ad-border-bottom-width);
  border-left-width: var(--ad-border-left-width);
  border-style: var(--ad-border-style, solid);
}

.ad-item[data-ad-padding] > :first-child {
  padding: var(--ad-padding);
}

.ad-item[data-ad-margin-bottom] {
  margin-bottom: var(--ad-margin-bottom);
}

.ad-item[data-ad-text-color] > :first-child,
.ad-item[data-ad-text-color] > :first-child :where(p, span, dd, dt, li, td, th) {
  color: var(--ad-text-color);
}

.ad-item[data-ad-font-family] > :first-child {
  font-family: var(--ad-font-family);
}

.ad-item[data-ad-font-size] > :first-child {
  font-size: var(--ad-font-size);
}

.ad-item[data-ad-text-align] > :first-child {
  text-align: var(--ad-text-align);
}

.ad-item[data-ad-show-title] > :first-child :is(h2, h3, .emr-chart-card__title) {
  display: var(--ad-title-display);
}

.ad-item[data-ad-title-size] > :first-child :is(h2, h3, .emr-chart-card__title) {
  font-size: var(--ad-title-size);
}

.ad-item[data-ad-title-weight] > :first-child :is(h2, h3, .emr-chart-card__title) {
  font-weight: var(--ad-title-weight);
}

.ad-item[data-ad-title-align] > :first-child :is(h2, h3, .emr-chart-card__title) {
  text-align: var(--ad-title-align);
  width: 100%;
}

/*
 * Native-card box cosmetics. Opt-in per element; tokens only. Width and align
 * stay inside the FLOW column the card already occupies — they do not span
 * columns and they do not change column or ordinal. Height is a min-height
 * floor so clinical content is never clipped. Nudge is a visual translate,
 * not a change to FLOW order.
 */
.ad-item[data-ad-card-width] {
  width: var(--ad-card-width);
  max-width: 100%;
}

.ad-item[data-ad-card-align] {
  margin-inline: var(--ad-card-align);
}

.ad-item[data-ad-card-height] > :first-child {
  min-height: var(--ad-card-height);
}

.ad-item[data-ad-card-nudge-y] {
  transform: translateY(var(--ad-card-nudge-y));
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-application-designer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;;;;;;;;;;EAWE;AACF;;EAEE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;EAeE;AACF;;EAEE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;;;;EAIE,iCAAiC;EACjC,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;;;8EAG8E;;AAE9E;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;;;;EASE;AACF;;EAEE,4CAA4C;EAC5C,gDAAgD;EAChD,kDAAkD;EAClD,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;;;;;;EAME;AACF;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/*\n * Application Designer — editor chrome, and the meaning of every cosmetic.\n *\n * Two halves.\n *\n * The first is the editor: the command bar, the per-element design chrome, the\n * hidden tray and the properties panel. These are the rules the Patient Summary\n * Design View shipped with, renamed from `.emr-summary-design-*` to `.ad-*` so\n * the next designable page inherits the same look instead of copying it.\n *\n * The second is the cosmetic contract. A stored cosmetic never becomes an inline\n * style: `cosmeticStyleProps` emits a CSS custom property plus a marker\n * attribute, and the rules below are the ONLY place that decides what a marker\n * does. A property with no rule here is inert, which is what makes the stored\n * value safe — a layout cannot express a declaration this file has not agreed to.\n *\n * Each rule targets `.ad-item[marker] > :first-child`, the native element itself,\n * so a page's own component keeps its markup and only the declarations that were\n * actually set are overridden. Three classes of specificity clears\n * `.emr-chart .emr-chart-card` without needing `!important`.\n */\n\n.ad-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.ad-bar__banner {\n  margin: 0;\n  flex: 1 1 280px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-chart-muted);\n}\n\n.ad-bar__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ad-bar__btn,\n.ad-item__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid var(--emr-chart-border);\n  background: #fff;\n  color: var(--emr-chart-text);\n  font-size: var(--emr-type-button-compact);\n  font-weight: 600;\n}\n\n.ad-bar__btn.is-primary {\n  border-color: var(--emr-chart-primary);\n  background: var(--emr-chart-primary);\n  color: #fff;\n}\n\n.ad-bar__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ad-item__design {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  padding: 6px;\n  border: 1px dashed #9dbbe0;\n  background: #f8fbff;\n}\n\n.ad-item__design.is-selected {\n  border-color: var(--emr-chart-primary);\n  border-style: solid;\n  background: #eef6ff;\n}\n\n.ad-item__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n.ad-item__label {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  text-align: left;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  color: var(--emr-chart-muted);\n  cursor: pointer;\n}\n\n.ad-item__label[aria-pressed=\"true\"] {\n  color: var(--emr-chart-primary);\n  text-decoration: underline;\n}\n\n.ad-item__grip {\n  display: inline-flex;\n  color: #7a8ea6;\n  cursor: grab;\n}\n\n.ad-item__btn {\n  height: 24px;\n  padding: 0 6px;\n}\n\n.ad-item__body {\n  min-width: 0;\n}\n\n.ad-item {\n  min-width: 0;\n}\n\n.ad-hidden {\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px dashed #c5cdd6;\n  background: #fafbfc;\n}\n\n.ad-hidden h3 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 8px;\n  font-size: var(--emr-type-card-title);\n}\n\n.ad-hidden ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ad-hidden li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/*\n * The panel sits below the page it edits, so it is as wide as the page. Laying\n * the groups out in columns keeps every control beside its own label: a single\n * full-width column would put the label at one edge of the screen and its\n * control at the other, which is a long way to travel to change a padding.\n *\n * The panel is an <aside>, and the Materialize overlay prefixed onto\n * `.emr-mz-dashboard` (see craco.config.js) sets `display: block` on every\n * semantic element at one class plus one element — which outranks a single\n * designer class. Without the prefixed selector here the panel stays a block and\n * collapses back to one full-width column.\n */\n.emr-mz-dashboard .ad-props,\n.ad-props {\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px solid var(--emr-chart-border);\n  background: #fff;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 0 24px;\n  align-items: start;\n}\n\n.ad-props__title,\n.ad-props__note {\n  grid-column: 1 / -1;\n}\n\n.ad-props__title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin: 0 0 8px;\n  font-size: var(--emr-type-card-title);\n}\n\n.ad-props__subject {\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  color: var(--emr-chart-primary);\n}\n\n.ad-props__note {\n  margin: 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-chart-muted);\n}\n\n.ad-props__group {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid var(--emr-chart-border);\n}\n\n.ad-props__group h4 {\n  margin: 0 0 6px;\n  font-size: var(--emr-type-metadata);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--emr-chart-muted);\n}\n\n/* Label and control in one row of the group's own narrow column. */\n.ad-props__field {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 8px;\n  min-height: 26px;\n}\n\n.ad-props__field > label {\n  font-size: var(--emr-type-helper);\n  color: var(--emr-chart-text);\n}\n\n/*\n * Materialize form controls, opted out of.\n *\n * The overlay replaces native controls with its own JS widgets, so it hides what\n * it means to replace: `select { display: none }`, and `[type=checkbox]` moved to\n * zero size at zero opacity. It also restyles text-like inputs — including\n * `number` — into a 3rem underline-only field at 16px with content-box sizing and\n * an 8px bottom margin. All of that is prefixed with `.emr-mz-dashboard`, which\n * puts `input[type=number]:not(.browser-default)` at three classes and one\n * element: past anything the panel can reach on specificity alone. This is the\n * same opt-out the Form Designer makes, for the same reason and in the same way.\n *\n * A control that is in the DOM with no box is worse than a missing control,\n * because it looks like a rendering glitch rather than a bug, so these rules are\n * pinned by `emr-application-designer.test.js`.\n */\n.emr-mz-dashboard .ad-props__field select,\n.ad-props__field select {\n  display: block;\n  appearance: auto;\n  -webkit-appearance: auto;\n}\n\n.emr-mz-dashboard .ad-props input[type=\"checkbox\"],\n.ad-props input[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  width: 13px !important;\n  height: 13px !important;\n  margin: 0 !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  accent-color: var(--emr-chart-primary);\n}\n\n.emr-mz-dashboard .ad-props__field select,\n.emr-mz-dashboard .ad-props__field input[type=\"number\"],\n.ad-props__field select,\n.ad-props__field input[type=\"number\"] {\n  box-sizing: border-box !important;\n  height: 24px !important;\n  width: 104px !important;\n  margin: 0 !important;\n  padding: 0 4px !important;\n  border: 1px solid var(--emr-chart-border) !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-size: var(--emr-type-helper) !important;\n}\n\n.ad-props__color {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ad-props__color input[type=\"color\"] {\n  width: 32px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid var(--emr-chart-border);\n  background: #fff;\n}\n\n.ad-props__clear {\n  height: 24px;\n  padding: 0 6px;\n  border: 1px solid var(--emr-chart-border);\n  background: #fff;\n  font-size: var(--emr-type-metadata);\n}\n\n.ad-props__clear:disabled {\n  opacity: 0.45;\n}\n\n.ad-props__sides {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ad-props__sides label {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-chart-muted);\n}\n\n/* ---------------------------------------------------------------------------\n * Cosmetic contract. One rule per allowlisted property; the marker attribute\n * is what activates it, so an unset property changes nothing.\n * ------------------------------------------------------------------------- */\n\n.ad-item[data-ad-background-color] > :first-child {\n  background: var(--ad-background);\n}\n\n.ad-item[data-ad-corner-radius] > :first-child {\n  border-radius: var(--ad-corner-radius);\n}\n\n.ad-item[data-ad-shadow] > :first-child {\n  box-shadow: var(--ad-shadow);\n}\n\n.ad-item[data-ad-border-color] > :first-child {\n  border-color: var(--ad-border-color);\n}\n\n.ad-item[data-ad-border-style] > :first-child {\n  border-style: var(--ad-border-style);\n}\n\n/*\n * Thickness is per side so \"which edges are visible\" is the same property as\n * \"how thick\": an edge the user turned off is emitted as 0px rather than\n * needing a second declaration. Setting a thickness therefore replaces the\n * card's own border shorthand on every edge, including the accent edge\n * `.emr-chart-card` draws on the right.\n *\n * Choosing edges alone activates the same rule, so \"which sides are visible\" is\n * not inert until a thickness is also picked.\n */\n.ad-item[data-ad-border-sides] > :first-child,\n.ad-item[data-ad-border-width] > :first-child {\n  border-top-width: var(--ad-border-top-width);\n  border-right-width: var(--ad-border-right-width);\n  border-bottom-width: var(--ad-border-bottom-width);\n  border-left-width: var(--ad-border-left-width);\n  border-style: var(--ad-border-style, solid);\n}\n\n.ad-item[data-ad-padding] > :first-child {\n  padding: var(--ad-padding);\n}\n\n.ad-item[data-ad-margin-bottom] {\n  margin-bottom: var(--ad-margin-bottom);\n}\n\n.ad-item[data-ad-text-color] > :first-child,\n.ad-item[data-ad-text-color] > :first-child :where(p, span, dd, dt, li, td, th) {\n  color: var(--ad-text-color);\n}\n\n.ad-item[data-ad-font-family] > :first-child {\n  font-family: var(--ad-font-family);\n}\n\n.ad-item[data-ad-font-size] > :first-child {\n  font-size: var(--ad-font-size);\n}\n\n.ad-item[data-ad-text-align] > :first-child {\n  text-align: var(--ad-text-align);\n}\n\n.ad-item[data-ad-show-title] > :first-child :is(h2, h3, .emr-chart-card__title) {\n  display: var(--ad-title-display);\n}\n\n.ad-item[data-ad-title-size] > :first-child :is(h2, h3, .emr-chart-card__title) {\n  font-size: var(--ad-title-size);\n}\n\n.ad-item[data-ad-title-weight] > :first-child :is(h2, h3, .emr-chart-card__title) {\n  font-weight: var(--ad-title-weight);\n}\n\n.ad-item[data-ad-title-align] > :first-child :is(h2, h3, .emr-chart-card__title) {\n  text-align: var(--ad-title-align);\n  width: 100%;\n}\n\n/*\n * Native-card box cosmetics. Opt-in per element; tokens only. Width and align\n * stay inside the FLOW column the card already occupies — they do not span\n * columns and they do not change column or ordinal. Height is a min-height\n * floor so clinical content is never clipped. Nudge is a visual translate,\n * not a change to FLOW order.\n */\n.ad-item[data-ad-card-width] {\n  width: var(--ad-card-width);\n  max-width: 100%;\n}\n\n.ad-item[data-ad-card-align] {\n  margin-inline: var(--ad-card-align);\n}\n\n.ad-item[data-ad-card-height] > :first-child {\n  min-height: var(--ad-card-height);\n}\n\n.ad-item[data-ad-card-nudge-y] {\n  transform: translateY(var(--ad-card-nudge-y));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
